import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EditorSidebar from '../../components/editor/Sidebar';
import EditorMessages from './EditorMessages';
import EditorRequestDetail from './EditorRequestDetail';

const EditorDashboard = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <EditorSidebar />
      <div className="flex-1">
        <Routes>
          <Route index element={<Navigate to="/editor/messages" replace />} />
          <Route path="messages" element={<EditorMessages />} />
          <Route path="requests/:requestId" element={<EditorRequestDetail />} />
        </Routes>
      </div>
    </div>
  );
};

export default EditorDashboard; 